export const preventNaN = (calc: number): number => (isNaN(calc) ? 0 : calc);
